const baseModalSettings = {
    overlay : {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(218, 218, 218, 0.8)',
        zIndex: 999,
        overflow: 'auto',
        height: '100%'
    },
    content : {
        //position: 'absolute',
        position: 'absolute',
        maxWidth: '700px',
        //minWidth: '400px',
        width: '100%',
        maxHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        //left: '20px',
        //right: '20px',
        top: '50%',
        left: '50%',
        right: 'auto',
        //top: '100px',
        //bottom: '0px',
        bottom: 'auto',
        transform: 'translate(-50%,-50%)',
        border: 'none',
        background: 'transparent',
        borderRadius: '4px',
        outline: 'none',
        overflow: 'visible',
        //overflowY: 'auto',
        WebkitOverflowScrolling: 'visible',
        padding: 0,

    }
};



export const SUBMIT_MODAL_SETTINGS = {
    ...baseModalSettings,
    content: {
        ...baseModalSettings.content,
        maxHeight: '400px',
        maxWidth: '600px'
    }
};

export const SCROLL_MODAL_SETTINGS = {
    ...baseModalSettings,
    content: {
        ...baseModalSettings.content,
        maxHeight: '400px',
        maxWidth: '600px'
    }
};
export default baseModalSettings;



// WEBPACK FOOTER //
// ./app/styles/modalSettings.js